<template>
  <a-modal
    title="操作"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
  >
    <a-form :form="form" :class="[status == 1 ? 'readOnly' : '']">
      <a-form-item style="display: none">
        <a-input v-decorator="['userId']" />
      </a-form-item>
      <a-form-item
        v-if="userType === '00' || userType === '66'"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="企业名称"
      >
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="['enterpriseId', { rules: [{ required: true, message: '请输入用户名' }] }]"
          @change="changeEnterprise"
          :allowClear="true"
          :disabled="enterpriseDisabled"
        >
          <a-select-option v-for="type in enterpriseMap" :key="type.enterpriseId"
            >{{ type.enterpriseName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名">
        <a-input v-decorator="['loginName', { rules: [{ required: true, message: '请输入用户名' }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="密码" v-if="isAdd === true">
        <a-input v-decorator="['password', { rules: [{ validator: this.isPwd, required: true }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
        <a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名' }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号">
        <a-input v-decorator="['phone', { rules: [{ validator: this.isPhone, required: true }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
        <a-select v-decorator="['status', { initialValue: '0', rules: [{ required: true, message: '请选择状态' }] }]">
          <a-select-option :value="'0'">正常</a-select-option>
          <a-select-option :value="'1'">禁用</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        v-if="(record.isMain === '1' && userType === '00') || record.isMain === '0'"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="拥有角色"
        hasFeedback
      >
        <a-select
          style="width: 100%"
          mode="multiple"
          v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]"
          :allowClear="true"
        >
          <a-select-option v-for="action in roleAll" :key="action.roleId">{{ action.roleName }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getRoleAll, enterpriseRoleList, editStaff, addStaff, enterpriseRoleAll } from '@/api/system'
import store from '@/store'
import { getselectCombox } from '../../../api/order/NewlyaddedOrderList'

export default {
  name: 'EntUserRegister',
  props: {
    deptTree: {
      type: Array,
      required: true
    }
  },
  components: {},
  data() {
    return {
      isAdd: true,
      visible: false,
      enterpriseId: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      roleAll: [],
      mdl: {},
      form: this.$form.createForm(this),
      record: {},
      userType: '',
      enterpriseMap: [],
      enterpriseDisabled: false,
      status: 0
    }
  },
  beforeCreate() {},
  async created() {
    // 企业名称
    await getselectCombox().then(res => {
      if (res.code === 0) {
        this.enterpriseMap = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  methods: {
    // 密码正则表达式

    isPwd(rule, value, callback) {
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (value && !pwdRegex.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    //手机号正则表达式
    isPhone(rule, value, callback) {
      const pwdRegex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入联系方式'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入11位联系方式'))
      } else {
        callback()
      }
    },
    add(userType) {
      this.status = 0
      this.roleAll = []
      this.userType = userType
      if (userType != '00') {
        this.loadRoleAll(store.getters.enterpriseId)
      }
      this.form.resetFields()
      this.isAdd = true
      this.visible = true
      this.enterpriseDisabled = false
      this.record.isMain = '0'
    },
    edit(record, status) {
      this.status = status
      // console.log(status,typeof (status))
      this.visible = true
      this.isAdd = false
      this.record = record
      this.enterpriseId = record.enterpriseId
      record.phone = record.phonenumber
      this.roleAll = []

      this.$nextTick(() => {
        this.userType = store.getters.userType
        if (record.enterpriseId !== undefined && record.enterpriseId !== '' && record.enterpriseId !== null) {
          if (this.userType === '00' && record.isMain === '1') {
            getRoleAll().then(res => {
              this.roleAll = res.rows
            })
          } else {
            enterpriseRoleAll({ enterpriseId: record.enterpriseId }).then(res => {
              this.roleAll = res.rows
            })
          }
          this.enterpriseDisabled = true
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(record)
          this.form.setFieldsValue({ enterpriseId: record.enterpriseName })
        })
      })
    },
    loadRoleAll(enterpriseId) {
      enterpriseRoleAll({ enterpriseId: enterpriseId }).then(res => {
        this.roleAll = res.rows
      })
    },
    changeEnterprise(value) {
      this.enterpriseId = value
      this.loadRoleAll(this.enterpriseId)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        values.enterpriseId = this.enterpriseId
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true
          if (this.isAdd) {
            values['userId'] = '0'
            values['userType'] = '22'
            if (this.userType !== '00') {
              values['enterpriseId'] = store.getters.enterpriseId
            }
            addStaff(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok', 1)
                  this.visible = false
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            editStaff(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok', 2)
                  this.visible = false
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
.readOnly {
  pointer-events: none;
}
</style>
